const updates = [
  {
    time: '2026.07.29',
    tag: '新增',
    content: '全新"热度榜单"功能上线，实时展示当前最受关注的爆料内容排名，助您快速锁定全网热点。',
  },
  {
    time: '2026.07.28',
    tag: '优化',
    content: '移动端浏览体验全面升级，页面加载速度提升40%，视频播放流畅度大幅改善。',
  },
  {
    time: '2026.07.27',
    tag: '更新',
    content: '本周新增娱乐圈爆料内容127条，其中独家首发内容占比超过30%。多个重磅爆料持续追踪中。',
  },
  {
    time: '2026.07.26',
    tag: '公告',
    content: '为保障用户访问体验，已全面升级服务器集群。高峰期访问不再卡顿，页面秒开速度持续优化中。',
  },
  {
    time: '2026.07.25',
    tag: '新增',
    content: '"焦点专题"栏目正式上线，每周围绕热点事件推出深度策划内容，多角度还原事件全貌。',
  },
  {
    time: '2026.07.24',
    tag: '优化',
    content: '内容审核机制升级，新增AI辅助核查系统。在保障内容真实性的同时将审核时效缩短至15分钟内。',
  },
  {
    time: '2026.07.23',
    tag: '公告',
    content: '91黑料7月访问量突破1500万次，感谢广大用户的支持与信任。我们将继续努力提供更优质的内容服务。',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="mb-10 text-center">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            📢 最新动态
          </h2>
          <p className="text-sm text-foreground-600">
            平台最新公告与功能更新，随时了解91黑料的最新变化
          </p>
        </div>
        <div className="relative">
          <div className="absolute left-[19px] top-3 bottom-3 w-px bg-background-300"></div>
          <div className="space-y-6">
            {updates.map((update, idx) => (
              <div key={idx} className="flex gap-5">
                <div className="relative z-10 w-10 h-10 rounded-full bg-background-50 border-2 border-primary-300 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <div className="w-2.5 h-2.5 rounded-full bg-primary-500"></div>
                </div>
                <div className="flex-1 bg-background-100 border border-background-200/60 rounded-xl p-4">
                  <div className="flex items-center gap-3 mb-2">
                    <span className="text-xs text-foreground-500 whitespace-nowrap">
                      {update.time}
                    </span>
                    <span
                      className={`px-2 py-0.5 rounded-full text-xs font-medium whitespace-nowrap ${
                        update.tag === '新增'
                          ? 'bg-accent-100 text-accent-700'
                          : update.tag === '优化'
                          ? 'bg-secondary-100 text-secondary-700'
                          : update.tag === '公告'
                          ? 'bg-primary-100 text-primary-700'
                          : 'bg-background-200 text-foreground-600'
                      }`}
                    >
                      {update.tag}
                    </span>
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed">
                    {update.content}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}